module.exports = __webpack_public_path__ + "static/media/cloud.52029e76.svg";